// 资质查路由模块
export default [
	{
		path: '/qualification-query',
		name: 'Search',
		redirect: '/qualification-query/index',
		component: () => import('@/views/qualificationQuery/index'),
		meta: { title: '资质查' },
		children: [
			{
				path: 'index',
				name: 'SearchIndex',
				component: () => import('@/views/qualificationQuery/home'),
				meta: { title: '资质查首页', whiteListed: true },
				redirect: '/qualification-query/company'
			},
			{
				path: 'person',
				name: 'SearchPerson',
				component: () => import('@/views/qualificationQuery/person'),
				meta: { title: '查人员', whiteListed: true }
			},
			{
				path: 'company',
				name: 'SearchCompany',
				component: () => import('@/views/qualificationQuery/company'),
				meta: { title: '查企业', whiteListed: true }
			},
			{
				path: 'project',
				name: 'SearchProject',
				component: () => import('@/views/qualificationQuery/project'),
				meta: { title: '查项目', whiteListed: true }
			},
			{
				path: 'companyDetail',
				name: 'SearchCompanyDetail',
				component: () => import('@/views/qualificationQuery/companyDetail'),
				meta: { title: '查企业详情', whiteListed: true }
			},
			{
				path: 'projectDetail',
				name: 'SearchProjectDetail',
				component: () => import('@/views/qualificationQuery/projectDetail'),
				meta: { title: '查项目详情', whiteListed: true }
			},
			{
				path: 'personDetail',
				name: 'SearchPersonDetail',
				component: () => import('@/views/qualificationQuery/personDetail'),
				meta: { title: '查人员详情', whiteListed: true }
			}
		]
	}
]
